import React from 'react';
import styled from "styled-components";
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme(); // Cria um tema padrão

const DemoPaper = styled(Paper)(({ theme }) => ({
  width: '100%', // Torna a largura 100% do contêiner para ser responsivo
  maxWidth: 320, // Define uma largura máxima para o papel
  height: 120,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#fafafa', // Fundo um pouco mais claro que o branco
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)', // Aplica sombra manualmente
  fontSize: '24px', // Tamanho do texto
  fontWeight: 'bold', // Texto em negrito
  textAlign: 'center',
  margin: '8px', // Define a margem diretamente em pixels
}));

const Conteiner = styled.div`
  display: flex; 
  flex-wrap: wrap; // Permite que os itens se ajustem dentro do contêiner
  justify-content: center; // Centraliza os itens no contêiner
  margin-top: 39px;
  width: 100%; // Usa 100% da largura disponível
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column; // Muda a direção do flex para coluna
    align-items: center; // Centraliza os itens na vertical
  }

  // Adiciona uma nova consulta de mídia para largura abaixo de 400px
  @media (max-width: 400px) {
    flex-direction: column; // Muda a direção do flex para coluna
    align-items: center; // Centraliza os itens na vertical
  }
`;

const AreaAtuacao = () => {
  return (
    <ThemeProvider theme={theme}> {/* Move o ThemeProvider para fora do Conteiner */}
      <Conteiner>
        {/* <Stack direction="column" spacing={2}> */}
          <DemoPaper elevation={5}>Assessoria e Consultoria Jurídica</DemoPaper>
          <DemoPaper elevation={5}>Assessoria em Negociação</DemoPaper>
          <DemoPaper elevation={5}>Consultoria Ativa</DemoPaper>
          <DemoPaper elevation={5}>Análise e Confecção de Contratos</DemoPaper>
        {/* </Stack> */}
      </Conteiner>
    </ThemeProvider>
  );
};

export default AreaAtuacao;
